module.exports = __webpack_public_path__ + "static/media/je_logo.b294a53e.png";